import { render, staticRenderFns } from "./ViewerXlsx.vue?vue&type=template&id=185c2b6d&scoped=true"
import script from "./ViewerXlsx.vue?vue&type=script&lang=js"
export * from "./ViewerXlsx.vue?vue&type=script&lang=js"
import style0 from "./ViewerXlsx.vue?vue&type=style&index=0&id=185c2b6d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c2b6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('185c2b6d')) {
      api.createRecord('185c2b6d', component.options)
    } else {
      api.reload('185c2b6d', component.options)
    }
    module.hot.accept("./ViewerXlsx.vue?vue&type=template&id=185c2b6d&scoped=true", function () {
      api.rerender('185c2b6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DocumentViewer/ViewerXlsx.vue"
export default component.exports